import { css } from 'styled-components';
import { key } from 'styled-theme';
import StyledButton from '@sizeid/commons/components/Button/styled/StyledButton';
import { elementSize, media } from '@sizeid/commons/utils/styles';
import { CSSInterpolation } from '@sizeid/commons/types';

export const advisorSectionStyle = css`
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  text-align: center;

  ${StyledButton} {
    margin-top: 20px;
  }
`;

export const sectionStyle = css`
  padding-top: 0 !important;
  padding-bottom: 80px !important;

  ${StyledButton} {
    margin-top: 20px;
  }
`;

export const signFormsBoxStyle = (advisor?: boolean): CSSInterpolation =>
  advisor
    ? css`
        h1 {
          margin-top: 40px;
        }
      `
    : css`
        h1 {
          margin-top: 0;
        }

        ${media.moreThan('sm')`
          width: 60%;
          margin: 0 auto;
        `};
      `;

export const signUpTabStyle = css`
  position: relative;

  .icon {
    position: relative;

    &:first-child {
      color: ${key('colors.black.light[300]')};
    }

    &:last-child {
      ${elementSize(13)};
      position: absolute;
      top: 0;
      left: 0;
    }
  }
`;

export const tabIconStyle = css`
  .icon {
    ${elementSize(1.25, 'em')};
    margin-right: 5px;
  }
`;

export const headerCss =
  'font-size: 24px; line-height: 31px; text-align: center;';
